export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').push([
        {
            name: '[[[Sztuczna inteligencja]]]',
            route: 'ai-settings',
            auth: { all: ['AdminPermissions@Ai'], any: [] }
        }
    ]);

    sitemap.find('[[[System]]]').before('[[[Monitoring]]]', [
        {
            name: '[[[Asystent AI]]]',
            icon: 'far fa-fw fa-microchip-ai',
            auth: { all: ['AdminPermissions@Ai'], any: [] },
            children: [
                {
                    name: '[[[Logi odpowiedzi chatu AI]]]',
                    route: 'ai-chat-response-logs',
                    children: [
                        {
                            name: '[[[Szczegóły wątku]]]',
                            route: 'ai-chat-response-logs-details',
                            visible: false
                        }
                    ]
                }
            ]
        }
    ]);

    sitemap.before('[[[Repozytorium plików]]]', [
        {
            name: '[[[Narzędzia AI]]]',
            short: '[[[AI]]]',
            icon: 'fal fa-fw fa-microchip-ai',
            namespace: 'Ideo.Core.Common.Application.Permissions.AiTools',
            children: [
                {
                    name: '[[[Czat z narzędziami]]]',
                    icon: 'far fa-fw fa-comments',
                    route: 'aitools-tools-ai-chat',
                    namespace: 'tools.general',
                    event: 'tools-ai-session',
                    auth: { all: ['ChatPermissions@Access'], any: [] }
                },
                {
                    name: '[[[Prawnik AI]]]',
                    icon: 'far fa-fw fa-file-text',
                    route: 'aitools-documents-chat',
                    namespace: 'documents.lawyer',
                    event: 'lawyer-ai-session',
                    auth: { all: ['ChatPermissions@Access'], any: [] }
                },
                {
                    name: '[[[Prawnik AI - Zarządzanie]]]',
                    icon: 'far fa-fw fa-folder-open',
                    route: 'aitools-documents-manage',
                    namespace: 'documents.manage',
                    event: 'lawyer-ai-session',
                    auth: { all: ['ChatPermissions@Access'], any: [] }
                }
            ]
        }
    ]);
};
